import {
    CREATE_ORDER_REQUEST,
    CREATE_ORDER_SUCCESS,
    CREATE_ORDER_FAIL
} from './orderConstants'
import api from '../../api/backend';

export const createOrder = (order) =>async (dispatch, getState) =>{

    try{
        dispatch({type : CREATE_ORDER_REQUEST})
    
        const {userLogin : {userInfo}} = getState()

        console.log(userInfo)
        const config = {
            headers: {
                'Content-Type' : 'application/json',
                Authorization : `Bearer ${userInfo.token}`
            }
        }

        const {data} = await api.post('/api/orders/', {order}, config)
    
        dispatch({type : CREATE_ORDER_SUCCESS, payload : data.order})
    }catch(err) {
        dispatch({type : CREATE_ORDER_FAIL, 
            payload : err.response && (err.response.data.message ? 
                                        err.response.data.message : err.message)})
    }
    
}